
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shopping-with-us/[[...slug]]",
      function () {
        return require("private-next-pages/shopping-with-us/[[...slug]].page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shopping-with-us/[[...slug]]"])
      });
    }
  